// Valeur du {paramètre} des textes de pied de page « ZERO KAMI v{version} · un jeu 0cog™ » : la version de package.json, injectée au
// build par vite.config.js (`define`).
export function legalParams(version = __APP_VERSION__) {
  return { version };
}
